module.exports = __webpack_public_path__ + "media/Diagnose Ninon_neu.851c537a.mp4";